import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import AppState from '../../../models/redux/state/app.state';
import './GlobalSpinner.css';

const GlobalSpinner = (): JSX.Element => {
  const isLoading = useSelector((state: AppState) => state.spinner.globalSpinner.isVisible);

  return (
    <Fragment>
      {isLoading ? (
        <div className="spinner-container">
          <CircularProgress size={100} />
        </div>
      ) : null}
    </Fragment>
  );
};

export default GlobalSpinner;
